import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {companyActionTypes, CompanyClearAction, LoadCompanySuccessAction} from '../actions/company-load';
import {Company} from '../models/company';

export interface CompanyState {
  company: Company;
}

const initialState: CompanyState = {
  company: undefined
};

export function CompanyReducer(state: CompanyState = initialState, action: Action): CompanyState {
  switch (action.type) {
    case companyActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case companyActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case companyActionTypes.CLEAR:
      return handleLoadClearActions(state, action);
    default:
      return state;
  }
}


function handleLoadSuccessAction(state: CompanyState, action: LoadCompanySuccessAction): CompanyState {
  return  {  company: action.payload  };
}

function handleLoadClearActions(state: CompanyState, action: CompanyClearAction): CompanyState {
  return initialState;
}

function handleLoadErrorActions(state: CompanyState): CompanyState {
  return state;
}


export const companySelectors = {
  company: (state: CompanyState) => _.get(state, 'company', null)
};
